export default {
    fullSizeEditorMinWidth: 1150,
    fullSizeEditorMinWidthExtraTools: 1575,
    fullSizeEditorMinWidthExtraToolsCollapsed: 1445,
    referenceWidth: 480
};
